import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AddSiteComponent } from '../add-site/add-site.component';
import { EstablishmentService } from '../../../../../../../services/establishment.service';
import { AuthService } from '../../../../../../../services/auth.service';
import { displayImg } from '../../../../../../../shared/utils/utils.functions';
import { FlagType } from '../../../../../../../shared/utils/enums';
import { AddressService } from '../../../../../../../services/address.service';
import { FlagService } from '../../../../../../../shared/services/flag.service';
import { CustomDialogComponent } from '../../../../../../../shared/custom-dialog/custom-dialog.component';
import { EtablissementData } from '../../../../../../../shared/utils/data/etablissments-data';

@Component({
  selector: 'app-site-adresse-detail',
  templateUrl: './site-adresse-detail.component.html',
  styleUrl: './site-adresse-detail.component.scss',
})
export class SiteAdresseDetailComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SiteAdresseDetailComponent>,
    private dialog: MatDialog,
    private establishmentService: EstablishmentService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private addressService: AddressService,
    private flag: FlagService,
    private auth: AuthService
  ) {}

  ngOnInit() {

  }

  openAddSiteDialog() {
    const dialog = this.dialog.open(AddSiteComponent, {
      width: '700px',
      autoFocus: false,
      data: {
        isModify: true,
        site: this.data,
      },
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.dialogRef.close();
        this.addressService.toggleRefreshData();
      }
    });
  }

  defineSocial() {
    const body = {
      adresseId: this.data.id,
      establishementId: this.auth.id,
      isSocial: true,
    };
    this.addressService.updateAddressSocial(body).subscribe({
      next: (res) => {
        this.addressService.toggleRefreshData();
        this.flag.displayFlag(
          `le site ${this.data.name} est défini comme siège social `,
          FlagType.success
        );
        this.dialogRef.close();
      },
    });
  }

  hideSiteDialog() {
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.monEtablissement.hideStatusDialog.title,
        description:
          EtablissementData.monEtablissement.hideStatusDialog.description,
        primaryLabel: this.data.isvisible
          ? EtablissementData.monEtablissement.hideStatusDialog
              .primaryButtonHide
          : EtablissementData.monEtablissement.hideStatusDialog
              .primaryButtonShow,
        secondaryLabel:
          EtablissementData.monEtablissement.hideStatusDialog.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        const body = {
          etablissementId: this.auth.id,
          id: this.data.id,
          isVisible: !this.data.isvisible,
        };
        this.addressService.hideSite(body).subscribe({
          next: (value) => {
            this.addressService.toggleRefreshData();
            this.dialogRef.close();
          },
        });
      }
    });
  }

  protected readonly displayImg = displayImg;
}
